import { Pipe, PipeTransform } from '@angular/core';

import { generateColor } from '../../utils';

@Pipe({
  name: 'generateColor',
})
export class GenerateColorPipe implements PipeTransform {
  transform(value: string): string {
    return generateColor(value);
  }
}
